import React from 'react';
import ReactDOM from 'react-dom';
import { App } from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';
import './styles/app.scss';
import 'babel-polyfill';
import './assets/styles/vendor.scss';
import './assets/styles/main.scss';
import { getCurrentSubdomain } from './commons/domain';
import dsslogo from './public/images/logos/dsslogo.png';
import gwlogo from './public/images/logos/gwlogo.png';
import delivermelogo from './public/images/logos/deliver-me-favicon.png';

// Helper to set favicon (removes all existing favicon tags before adding new)
const setFavicon = (url) => {
    // Remove all existing favicon tags
    const links = document.querySelectorAll('link[rel*="icon"]');
    links.forEach(link => link.parentNode.removeChild(link));
    // Add new favicon
    const newLink = document.createElement('link');
    newLink.type = 'image/png';
    newLink.rel = 'icon';
    newLink.href = url;
    document.getElementsByTagName('head')[0].appendChild(newLink);
};

const subdomain = getCurrentSubdomain();
const theme = localStorage.getItem('theme');

if (subdomain.indexOf('gw') !== -1 || theme === 'gw-theme') {
    console.log('Applying GW theme');
    document.body.classList.add('gw-theme');
    document.body.classList.remove('dss-theme');
    document.title = 'Gebrüder Weiss';
    localStorage.setItem('theme', 'gw-theme');
    setFavicon(gwlogo);
} else if (subdomain.indexOf('dss') !== -1 || theme === 'dss-theme') {
    console.log('Applying DSS theme');
    document.body.classList.add('dss-theme');
    document.body.classList.remove('gw-theme');
    document.title = 'DSS';
    localStorage.setItem('theme', 'dss-theme');
    setFavicon(dsslogo);
} else {
    console.log('Applying default theme');
    document.body.classList.remove('gw-theme');
    document.body.classList.remove('dss-theme');
    document.title = 'Deliver Me';
    localStorage.removeItem('theme');
    setFavicon(delivermelogo);
}

ReactDOM.render(<App />, document.getElementById('app'));



// WEBPACK FOOTER //
// ./src/index.js